export default [
  {
    time: "6月15日 周六 9:00-12:00",
    teacher: {
      name: "冯岩",
      title: "海川百纳商业管理有限公司 联合创始人",
    },
    title: "商业思维 与 女性创业",
    type: "线下 沙龙",
    address: "菁蓉汇3A座9楼路演厅",
  },
  {
    time: "6月15日 周六 14:00-17:00",
    teacher: {
      name: "TommyDu",
      title: " TOMMY & BROTHER 创始人",
    },
    title: "商业模式",
    type: "线下 沙龙",
    address: "菁蓉汇3A座9楼路演厅",
  },
  {
    time: "6月19日 周三 19:00-21:30",
    teacher: {
      name: "赵明月",
      title: "达律师事务所 华嘉律师团队 联合创始人",
    },
    title: "创业公司 的 法律风险防控",
    type: "线下 沙龙",
    address: "菁蓉汇3A座9楼路演厅",
  },
  {
    time: "6月22日 周六 9:00-12:00",
    teacher: {
      name: "邱晓虹",
      title: " PMInternational  总裁",
    },
    title: "个人天赋 发现与发挥 （上）",
    type: "线下 沙龙",
    address: "菁蓉汇3A座9楼路演厅",
  },
  {
    time: "6月22日 周六 14:00-17:00",
    teacher: {
      name: "邱晓虹",
      title: " PMInternational  总裁",
    },
    title: "（选修） 个人天赋 发现与发挥 （下）",
    type: "线下 沙龙",
    address: "菁蓉汇3A座9楼路演厅",
  },
  {
    time: "6月26日 周三 19:00-21:30",
    teacher: {
      name: "张梦佳",
      title: " 《拆解》  作者",
    },
    title: "结构思考 与 商业模式论证",
    type: "线下  沙龙",
    address: "菁蓉汇3A座9楼路演厅",
  },
  {
    time: "6月30日 周日 9:00-12:00",
    teacher: {
      name: "肖龙",
      title: "阿么 创始人",
    },
    title: "从品牌注册到 销售上亿的坑和方法",
    type: "线下 沙龙",
    address: "菁蓉汇3A座9楼路演厅",
  },
  {
    time: "6月30日 周日 14:00-17:00",
    teacher: {
      name: "Mercury",
      title: "M Studio 花与礼物 创始人",
    },
    title: "初创公司品牌如何以小博大",
    type: "线下 沙龙",
    address: "菁蓉汇3A座9楼路演厅",
  },
  {
    time: "7月3日 周三 19:00-21:30",
    teacher: {
      name: "陈秋晖",
      title: "久谦教育创始人",
    },
    title: "品牌如何 输出",
    type: "线下 培训",
    address: "菁蓉汇3A座9楼路演厅",
  },
  {
    time: "7月7日 周日 9:00-12:00",
    teacher: {
      name: "朱绯",
      title: "立美皮肤管理机构 主理人",
    },
    title: "如何有效 开发和 管理客户 （上）",
    type: "线下 培训",
    address: "菁蓉汇3A座9楼路演厅",
  },
  {
    time: "7月7日 周日 14:00-17:30",
    teacher: {
      name: "朱绯",
      title: "立美皮肤管理机构 主理人",
    },
    title: "（选修） 如何有效 开发和 管理客户 （下）",
    type: "线下 培训",
    address: "菁蓉汇3A座9楼路演厅",
  },
  {
    time: "7月10日 周三 19:00-21:30",
    teacher: {
      name: "周颖",
      title: "成都云中山谷农业科技有限公司创始人",
    },
    title: "如何通过品牌升级实现业绩增长",
    type: "线下 培训",
    address: "菁蓉汇3A座9楼路演厅",
  },
  {
    time: "7月14日 周日 9:00-12:00",
    teacher: {
      name: "吴雅阁",
      title: "俊诚传媒 高级合伙人",
    },
    title: "如何打造客户的 极致体验",
    type: "线下 培训",
    address: "菁蓉汇3A座9楼路演厅",
  },
  {
    time: "7月14日 周日 14:00-17:00",
    teacher: {
      name: "李宁川",
      title: "AK学院 创始人",
    },
    title: "技术如何为创业提供助力",
    type: "线下 培训",
    address: "菁蓉汇3A座9楼路演厅",
  },
  {
    time: "7月17日周三 19:00-21:30",
    teacher: {
      name: "曹逸韵",
      title: "pinkLab 创始人",
    },
    title: "如何打造一个大众点评全城第1的实体店",
    type: "线下 培训",
    address: "菁蓉汇3A座9楼路演厅",
  },
  {
    time: "7月21日 周日 9:00-12:00",
    teacher: {
      name: "王婷",
      title: "汇智广通财务咨询 创始人",
    },
    title: "财务流程规范实操",
    type: "线下 培训",
    address: "菁蓉汇3A座9楼路演厅",
  },
  {
    time: "7月21日 周日 14:00-17:00",
    teacher: {
      name: "王婷",
      title: "汇智广通财务咨询 创始人",
    },
    title: "税务基本常识",
    type: "线下 培训",
    address: "菁蓉汇3A座9楼路演厅",
  },
  {
    time: "7月24日 周三 19:00-21:30",
    teacher: {
      name: "熊瑶",
      title: "51社保 成都分公司 总经理",
    },
    title: "人力规划 与 绩效管理",
    type: "线下 沙龙",
    address: "菁蓉汇3A座9楼路演厅",
  },
  {
    time: "7月28日 周日 9:00-12:00",
    teacher: {
      name: "鹿雯立",
      title: "中国幸福教练联盟 发起人",
    },
    title: "如何进行有效沟通， 降低企业内耗",
    type: "线下 培训",
    address: "菁蓉汇3A座9楼路演厅",
  },
  {
    time: "7月28日 周日 14:00-17:00",
    title: "营销项目",
    type: "线下 实操演练",
    address: "小组自选商圈",
  },
  {
    time: "7月31日 周三 19:00-21:30",
    teacher: {
      name: "王信民",
      title: "壹柒玖捌创新创业投资中心 创始人",
    },
    title: "如何撩上投资人",
    type: "线下 培训",
    address: "菁蓉汇3A座9楼路演厅",
  },
  {
    time: "8月4日 周日 9:00-17:00",
    teacher: {
      name: "小佑",
      title: "蓝计划创始人",
    },
    title: "PPT策划与制作",
    type: "线下 培训",
    address: "菁蓉汇3A座9楼路演厅",
  },
  {
    time: "8月18日",
    title: "第6期创业女性训练营毕业典礼",
    type: "毕业典礼",
    address: "待定",
  },
];
